export const ITEM_TYPES = {
  TEXT: 'text',
}
